const CONSTANTS = {
  SIGN_UP_BASIC_INFO: "basic info",
  SIGN_UP_OTP_VERIFICATION: "otp verification",
  SIGN_UP_SUBSCRIPTION: "subcription plans",
  SIGN_UP_BODY_SCANNING: "body scan",
  SIGN_UP_FACE_SCANNING: "face scan",
  SIGN_UP_SUCCESS: "success",
  SIGN_UP_CATEGORIES: "categories",
  MOBILE_VIEW_MAX_WIDTH: "(max-width:767px)",
  APPAREL: "apparel",
  COSMETICS: "cosmetics",
  APPAREL_TITLE: "Apparel",
  COSMETICS_TITLE: "Cosmetics",
  ACCESS_TOKEN: "access-token",
};
export default CONSTANTS;
